import type { Timestamp } from 'firebase/firestore'

export const ROLES = ['admin', 'supplier', 'client'] as const

export type Role = (typeof ROLES)[number]

/** Runtime type-guard for a role value coming from an untrusted source (e.g. a token claim). */
export function isRole(value: unknown): value is Role {
  return value === 'admin' || value === 'supplier' || value === 'client'
}

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Admin',
  supplier: 'Supplier',
  client: 'Client',
}

/** Firestore `users/{uid}` document (blueprint §4.1). Written only by Cloud Functions. */
export interface UserDoc {
  name: string
  email: string
  role: Role
  suspended: boolean
  projectCount: number
  createdAt: Timestamp
  createdBy: string
}
